import React, { useState, useEffect } from 'react'
import { raplaceEmoji, filterIllegalCharacters, calcCharactersLength, sliceCharactersLen } from '../../utils/utils'

interface InputLimitByteLengthProps {
  value?: string,
  maxLength: number,          //最大字符数
  onChange: (e) => void
}

export const InputLimitByteLength: React.FC<InputLimitByteLengthProps> = (props: InputLimitByteLengthProps) => {
  const { value, onChange, maxLength } = props
  const inputRef: any = React.useRef(null)
  const [isOnComposition, setOnCompisition] = useState(false)

  useEffect(() => {
    setInputValue(value)
  }, [value])

  const setInputValue = (value = '') => {
    value = raplaceEmoji(value)
    value = filterIllegalCharacters(value)
    if (maxLength && !calcCharactersLength(value, maxLength)) {
      value = sliceCharactersLen(value, maxLength)
    }
    if (inputRef && inputRef.current) {
      inputRef.current.value = value
      onChange(value)
    }
  }

  const handleComposition = (e) => {
    if (e.type === 'compositionend') {
      setOnCompisition(false)
      // 谷歌浏览器：compositionstart onChange compositionend
      // 火狐浏览器：compositionstart compositionend onChange
      if (navigator.userAgent.indexOf('Chrome') > -1) {
        setInputValue(e.target.value)
      }
      return;
    }
    setOnCompisition(true)
  }

  const onInputChange = (e) => {
    if (!isOnComposition) {
      setInputValue(e.target.value)
    }
  }

  const commonProps = {
    onChange: onInputChange,
    onCompositionStart: handleComposition,
    onCompositionUpdate: handleComposition,
    onCompositionEnd: handleComposition,
  }

  return <input
    className="ant-input"
    ref={inputRef}
    {...commonProps}
  />
}